import React, { useRef } from 'react';
import CreativeMessage from './CreativeMessage';
import { PaperClipIcon } from '@heroicons/react/24/outline';

export default function CreativeChatLayout({
  creative,
  messages,
  draft,
  setDraft,
  loading,
  sending,
  uploading,
  error,
  scrollRef,
  sendMessage,
  uploadAsset,
  title = 'Chat do Criativo',
  subtitle = 'Refine seu conteúdo por conversa.',
  actions = null,
}) {
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (!file || !uploadAsset) return;
    const isLogo = file.name.toLowerCase().includes('logo');
    uploadAsset(file, isLogo ? 'logo' : 'image');
    event.target.value = '';
  };

  const isImageCreative = creative?.creative_type === 'image';

  return (
    <div className="creative-chat-page">
      <header className="creative-chat-page__header card">
        <div>
          <h1>{creative?.title || title}</h1>
          <p>{creative?.prompt || subtitle}</p>
          {creative?.version > 1 && (
            <span className="creative-chat-page__version">v{creative.version}</span>
          )}
        </div>
        {actions ? <div className="creative-chat-page__actions">{actions}</div> : null}
      </header>

      <main className="creative-chat-page__messages card" ref={scrollRef}>
        {loading ? <p className="creative-chat-page__status">Carregando conversa...</p> : null}
        {!loading && messages.length === 0 ? <p className="creative-chat-page__status">Nenhuma mensagem ainda.</p> : null}
        {messages.map((message) => (
          <CreativeMessage key={message.id} message={message} />
        ))}
        {uploading && <p className="creative-chat-page__status">Enviando arquivo...</p>}
      </main>

      {error ? <p className="creative-chat-page__error">{error}</p> : null}

      <footer className="creative-chat-page__input card">
        <form
          onSubmit={(event) => {
            event.preventDefault();
            if (!sending) sendMessage();
          }}
        >
          {isImageCreative && uploadAsset && (
            <>
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                style={{ display: 'none' }}
              />
              <button
                type="button"
                className="btn btn-ghost creative-chat-page__upload-btn"
                onClick={() => fileInputRef.current?.click()}
                disabled={uploading || sending}
                title="Enviar logo ou imagem"
              >
                <PaperClipIcon className="icon-sm" />
              </button>
            </>
          )}
          <input
            type="text"
            value={draft}
            onChange={(event) => setDraft(event.target.value)}
            placeholder={isImageCreative ? 'Peça ajustes na imagem, texto, cores...' : 'Peça ajustes no criativo...'}
            disabled={sending}
          />
          <button type="submit" className="btn btn-primary" disabled={sending || !draft.trim()}>
            {sending ? 'Enviando...' : 'Enviar'}
          </button>
        </form>
      </footer>
    </div>
  );
}
